import * as React from "react"
import { HorizontalSpacer } from "../../atoms/spacers"
import { Container } from "react-grid-system"
import Card from "../../atoms/Card"
import Subtitle from "../../atoms/typography/Subtitle"
import BodyLarge from "../../atoms/typography/BodyLarge"
import H1 from "../../atoms/typography/H1"

const TermsAndConditionsPage: React.FunctionComponent = () => {
  React.useEffect(() => {
    document.title = "Terms and conditions"
  }, [])

  return (
    <div>
      <HorizontalSpacer spacing={2} />
      <Container>
        <Card>
          <div style={{ padding: "2rem" }}>
            <HorizontalSpacer spacing={2} />
            <H1>Terms and conditions</H1>
            <HorizontalSpacer spacing={2} />

            <Subtitle>General terms</Subtitle>
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                1. These general terms <b>(the “Terms”)</b> shall apply to all users who register for an account with
                Satcube AB <b>(“Satcube”, “we”, “us” or “our”)</b> for the purposes of logging into Satcube’s online
                site and accessing further information about our products and services, whether the site is made
                available on or through our website (www.satcube.com) or such other domain, platform or application as
                we may use from time to time (collectively, the
                <b>“Site”</b>). By agreeing to register for an account with Satcube
                <b>(“Account”)</b>, you confirm that you accept these Terms and that you agree to comply with them. We
                recommend that you keep a copy of these Terms for future reference.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                2. Satcube is a company incorporated under the laws of Sweden with its office located at Nellickevägen
                22, 412 63, Gothenburg, Sweden, with official registration number 556701-2769. visit, page views, and
                website navigation paths.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />

            <Subtitle>User Account</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                3. You may use your Account to log into Satcube’s Site, access further information about our products
                and services, and order certain products and services that we may make available from time to time,
                subject to the other provisions of these Terms.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                4. We may update and change our Site from time to time, including (without limitation) regarding any
                products, services and pricing that may be made available on the Site.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                5. Any order or purchase of goods and/or services from the Site will be subject to further terms and
                conditions (which shall be notified to you prior to the placing of your order or purchase).
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                6. If you choose, or you are provided with, a user identification code, password or any other piece of
                information as part of our security procedures, you must treat such information as confidential and you
                must not disclose it to any third party.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                7. We reserve the right to disable any user identification code or password (whether chosen by you or
                allocated by us) and to restrict your access to your Account and/or the Site if, in our opinion, you
                have failed to comply with any provision of these Terms.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                8.If you know or suspect that anyone other than you knows your user identification code or password, you
                must promptly notify us (see the Contact section below).
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Prohibited uses</Subtitle>
            <HorizontalSpacer spacing={1} />

            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                9. You may use your Account and the Site only for lawful purposes. You may not use your Account and/or
                the Site:
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <div style={{ padding: "1rem" }}>
                <BodyLarge>
                  a. in any way that breaches any applicable law or regulation;th any ongoing or prospective legal
                  proceedings;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  b. in any way that is unlawful or fraudulent or has any unlawful or fraudulent purpose or effect;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  c. to transmit, or procure the sending of, any unsolicited or unauthorised advertising or promotional
                  material or any other form of similar solicitation (e.g. spam);
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  d. to transmit, send or upload any data or material that contains any virus, malware or harmful
                  programs or codes designed to adversely affect or interfere with the operation of any computer
                  software, hardware, files, data or other information <b>(“Malicious Software”)</b>, whether or not
                  wilfully or negligently transmitted, sent or uploaded;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  e. to gain unauthorised access to any user account, the Site, the server on which the Site is stored
                  or any server, computer or database connected to the Site.
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
              </div>
            </div>

            <HorizontalSpacer spacing={2} />

            <Subtitle>Availability</Subtitle>
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                10. We do not represent nor guarantee that access to your Account or the Site, including any content on
                it, will always be available, uninterrupted or error-free.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                11. We may suspend, withdraw or restrict the availability of all or any part of your Account or the Site
                for business and operational reasons.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                12. Other than as expressly set out in these Terms, we make no representation, warranty or guarantee
                that: (a) the content in your Account or the Site is accurate, complete or up-to-date; and/or (b) your
                Account and/or the Site (or any content therein) is appropriate for use or is available in any location
                outside of Sweden. You are responsible for configuring your devices and information technology to access
                the Site.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                13. We do not guarantee that the Site will be secure or free from Malicious Software. You should use
                your own virus protection software.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />

            <Subtitle>Intellectual property rights</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                14. We are the owner or the licensee of all intellectual property rights in the Site and reserve all our
                rights in such regard. You are not permitted to use any of our intellectual property rights without our
                prior written consent.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Links to third party sites and content</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                15. Where the Site contains links to other sites and resources provided by third parties, such links are
                provided for your information only. Such links should not be interpreted as approval by us of those
                linked websites or information you may obtain from them. We have no control over the contents of those
                sites or resources.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                16. The Site may include information and materials uploaded by other users of the Site. Such information
                and materials have not been verified or approved by us. The views expressed by other users on our Site
                do not represent our views or values.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Limitation of liability</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                17. Unless otherwise required by law: (i) we shall not be liable to you for any loss or damage arising
                under or in connection with these Terms including (without limitation) use of, or inability to use, your
                Account or the Site; (ii) our liability (to the extent required by law) arising under or in connection
                with these Terms shall be limited to your direct costs and we will under no circumstances be liable for
                any indirect or consequential damages, including but not limited to loss of revenue, loss of profits,
                business or anticipated savings or any other indirect damage or loss of data. Furthermore, Satcube is
                never liable for your liability towards a third party. The limitation of liability set out in this
                Clause does not apply in the event of willful intent or gross negligence on the part of Satcube.
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <BodyLarge>
                18. To the fullest extent permissible by law, Satcube excludes all implied conditions, warranties and
                representations that may apply to the provision or use of the Site and your Account (including any
                content therein).
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Personal data</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                19. When registering for an Account, you will be asked to provide certain information including personal
                data about yourself. Please see our Privacy Policy [insert link to privacy policy] for further
                information and more information about your rights regarding your data. You can also contact us (see
                contact information below) if you should have any questions regarding our processing of your personal
                data.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Breach</Subtitle>
            <HorizontalSpacer spacing={1} />

            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                20. Your failure to comply with the provisions of these Terms may constitute a material breach and may
                result in our taking all or any of the following actions (or such other action as we may deem
                appropriate from time to time):
              </BodyLarge>
              <HorizontalSpacer spacing={0.5} />
              <div style={{ padding: "1rem" }}>
                <BodyLarge>
                  a. temporary or permanent suspension, withdrawal or restriction of your right to use your Account
                  and/or the Site;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>b. issue of a warning to you;</BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  c. legal proceedings against you for reimbursement of our costs on an indemnity basis (including,
                  without limitation, reasonable administrative and legal costs) resulting from your breach;
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>d. further legal action against you; and/or</BodyLarge>
                <HorizontalSpacer spacing={0.5} />
                <BodyLarge>
                  e. disclosure of such information to law enforcement authorities as we reasonably consider to be
                  necessary or as otherwise required by law.
                </BodyLarge>
                <HorizontalSpacer spacing={0.5} />
              </div>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Non-waiver</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                21. No consent or waiver, express or implied, by either party of any breach or default of the other
                party in performing its obligations under or in connection with these Terms shall be deemed or construed
                to be a consent or waiver of any other breach or default by the other party of the same or any other
                obligation hereunder. Any failure by one party to complain of any act or failure to act of the other
                party or to declare that other party in default shall not constitute a waiver by the first party of its
                rights under or in connection with these Terms. No waiver of any rights under or in connection with
                these Terms under this Agreement shall be effective unless in writing and signed by the party purporting
                to give the same.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Transfer of rights</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                22. We may transfer our rights and obligations under these Terms to any third party at any time,
                provided this does not adversely affect your rights under these Terms.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Governing law and jurisdiction</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                23. These Terms shall be governed by Swedish law, without application of its conflict of law provisions.
                Any dispute, controversy or claim arising out of or in connection with these Terms shall be settled in
                general courts, with Stockholms tingsrätt as the first instance.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
            <Subtitle>Contact</Subtitle>
            <HorizontalSpacer spacing={1} />
            <div style={{ padding: "1rem" }}>
              <BodyLarge>
                24. f you have any questions regarding these Terms or your Account, please contact us at
                info@satcube.com or +46 (0) 31 701 05 00.
              </BodyLarge>
            </div>

            <HorizontalSpacer spacing={2} />
          </div>
        </Card>
        <HorizontalSpacer spacing={2} />
      </Container>
    </div>
  )
}

export default TermsAndConditionsPage
